import React, { useContext, useMemo } from 'react';
import moment from 'moment/moment';

import { CREDIT_MEMO, DEBIT_MEMO } from 'components/pages/finance/NewInvoice/InvoiceTable/TableConstants';
import { InvoiceContext } from 'components/pages/finance/NewInvoice/NewInvoiceContext';
import { isAdjustmentEventType, isParentPDF } from 'components/pages/finance/NewInvoice/services/service';

import { stylesContent } from '../../EncounterInvoiceTemplateStyles';

const ADJUSTMENT_SUFFIX_MAP = {
  [CREDIT_MEMO]: 'CM',
  [DEBIT_MEMO]: 'DM'
};

export const Expense = ({ item, invoiceType }) => {
  const { includeAdjustments } = useContext(InvoiceContext);
  let content = useMemo(() => {
    if (includeAdjustments && isAdjustmentEventType(item.invoiceType) && isParentPDF(invoiceType)) {
      return ADJUSTMENT_SUFFIX_MAP[item.invoiceType];
    }
    return `${item.expenseComment ? item.expenseComment : ''} ${
      item?.eventDate ? `(${moment(item.eventDate).format('DD-MMM-YYYY')})` : '—'
    }`;
  }, [invoiceType, includeAdjustments, item]);

  return (
    <div style={{ ...stylesContent.invoiceItem, display: 'flex' }} className="row-item" data-testid="ledger-event-item">
      <div style={{ width: item.invoiceType === 'CREDIT_MEMO' ? '270px' : '274px' }}>{content}</div>
      <div>{item.rate}</div>
    </div>
  );
};
